// Import model
import { StartEstimateEditSectionRequest } from '../models/StartEstimateEditSectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartEstimateEditSectionRequest - handles JSON serialization and deserialization with type validation
 */
export class StartEstimateEditSectionRequestSerializer {
  /**
   * Deserializes a JSON string into a StartEstimateEditSectionRequest instance
   */
  static deserialize(json: string): StartEstimateEditSectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartEstimateEditSectionRequest instance
   */
  static fromObject(obj: any): StartEstimateEditSectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartEstimateEditSectionRequest');
    }


    const instance: StartEstimateEditSectionRequest = {
      name: obj['name'] as string | undefined,
      content: obj['content'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartEstimateEditSectionRequest instances
   */
  static deserializeArray(json: string): StartEstimateEditSectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartEstimateEditSectionRequest instance to a JSON string
   */
  static serialize(instance: StartEstimateEditSectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartEstimateEditSectionRequest instance to a plain object
   */
  static toObject(instance: StartEstimateEditSectionRequest): any {
    return {
      'name': instance.name,
      'content': instance.content,
      'contentType': instance.contentType,
    };
  }

  /**
   * Serializes an array of StartEstimateEditSectionRequest instances to a JSON string
   */
  static serializeArray(instances: StartEstimateEditSectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
